import { FC, FormEvent } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import PersonalInfo from 'components/forms/PersonalInfo/SSN';
import values from 'stores/values';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import { AccountFormutil } from '../../type';

const BaseInfo2: FC<ProgressFormProps> = ({ onSubmit }) => {
    const { id_type } = values.getParams<AccountFormutil>();

    const handleSubmit = (ev: FormEvent) => {
        onSubmit('../address', ev);

        reportEventList('personalInfo');
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('PERSONAL INFORMATION')}</h3>
            <PersonalInfo
                type="baseinfo2"
                idNumberProps={{
                    maskIdNo: null,
                    idType: id_type
                }}
            />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 1,
    id: 'baseinfo2',
    basePath: 'open',
    ensure: ['account', 'baseinfo'],
    showProgressBar: true,
    eventParams: {
        exposureEventParams: {
            model: '开户-基础信息2',
            name: '基础信息2-页面曝光'
        },
        submitEventParams: {
            model: '开户-基础信息2',
            name: '基础信息2-点击下一步'
        }
    }
})(BaseInfo2);
